export default __webpack_public_path__ + "static/media/tg.1d2ad5dc.svg";